import {type HttpError} from '@services/utils';

export const mapAuthError = (err: HttpError): string => {
  const status =
    typeof err.body === 'object' && err.body !== null && 'status' in err.body
      ? String((err.body as {status: unknown}).status)
      : err.message;

  switch (status) {
    case 'wrong_password':
      return 'Неверный пароль';
    case 'not_found':
    case 'user_not_found':
      return 'Пользователь с таким email не найден';
    case 'token_is_invalid':
      return 'Сессия истекла, войдите заново';
    default:
      return 'Не удалось войти. Попробуйте позже.';
  }
};
